/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import {Header, HeaderProps} from './Header';

export const CACHEABLE_HEADER_PLACEHOLDER = '###DESKTOP_HEADER###';

export const CacheableHeader: React.FC<HeaderProps> = Header;
